var clickCallbacks = {
  "_kviq_ec": pdp_vipps_express_clicked,
  "pdp-vipps_express_clicked": pdp_vipps_express_clicked,
  "pdp-add-to-cart": pdp_cart_clicked,
  "pdp-cart_presale_clicked": pdp_cart_presale_clicked,
  "pdp-cart_returpresale_clicked": pdp_cart_returpresale_clicked,
  "notifiy_stock_clicked": notifiy_stock_clicked,
  "pdp-wishlist_add": pdp_wishlist_add,
  "pdp-wishlist_remove": pdp_wishlist_remove,
  "pdp-colorswatch": pdp_colorswatch_clicked,
  "pdp-sizeguide": pdp_sizeguide_clicked,
  "pdp-delivery": pdp_delivery_clicked,
  "pdp-return": pdp_return_clicked,
  "pdp-recommendation_clicked": pdp_recommendation_clicked,
  "pdp-recommendations_seen": pdp_recommendations_seen,
  "back-in-stock-popup-ok_clicked": back_in_stock_popup_ok_clicked,
  "footer-registrer-retur": footer_returnpolicy_clicked,
  "footer-kjøpsvilkår": footer_buyterms_clicked,
  "footer-kontakt-oss": footer_contact_clicked,
  "footer-om-villoid": footer_about_clicked,
  "footer-newsletter_clicked": footer_newsletter_clicked,
  "front-campaign_clicked": front_campaign_clicked,
  "front-campaign_viewed": front_campaign_viewed,
  "front-category_clicked": front_category_clicked,
  "front-recos_news_clicked": front_recos_news_clicked,
  "front-recos_person_clicked": front_recos_person_clicked,
  "header-menu_item_clicked": header_menu_item_clicked,
  "header-wishlist_open": header_wishlist_open,
  "header-cart_open": header_cart_open,
  "header-account_clicked": header_account_clicked,
  "header-announce_delivery_clicked": header_announce_delivery_clicked,
  "header-search_clicked": header_search_clicked,
  "header-announcement_clicked": header_announcement_clicked,
  "account-register_clicked": account_register_clicked,
  "account-login_clicked": account_login_clicked,
  "account-login_successful": account_login_successful,
  "pages-filter_clicked": pages_filter_clicked,
  "pages-sort_clicked": pages_sort_clicked,
  "pages-badge_clicked": pages_badge_clicked,
  "pages-wishlist_add": pages_wishlist_add,
  "pages-wishlist_remove": pages_wishlist_remove,
  "wishlist_add_to_cart": wishlist_add_to_cart,
  "wishlist-heart-clicked": wishlist_heart_clicked,
  "wishlist-heart-in-cart-clicked": wishlist_heart_in_cart_clicked,
  "category_buttons_clicked": category_buttons_clicked,
  "cart-checkout_clicked": cart_checkout_clicked,
  "bsdt-popup-goto-checkout": bsdt_popup_goto_checkout,
  "cart-vipps_express_clicked": cart_vipps_express_clicked,
  "checkout-frakt_clicked": checkout_frakt_clicked,
  "checkout-go_to_payment": checkout_go_to_payment,
  "reductions": checkout_discount_clicked,
  "swatch-clicked": swatch_clicked,
  "quick-add-to-cart-clicked": quick_add_to_cart_clicked,
  "quick-add-to-cart-added": quick_add_to_cart_added,
  "login-vipps": login_vipps,
  "customer-auth-start": customer_auth_start,
  "login-email-password": login_email_password,
  "badge-click": badge_click,
  "grid-product-link": grid_product_link,
  "vipps-purchase-completed": vipps_purchase_completed,
  "cart-drawer-discount-code-apply": cart_drawer_discount_code_apply,
  "login-vipps-prompted-after-add-to-cart": login_vipps_prompted_after_add_to_cart,
  "autocomplete_open_chat": autocomplete_open_chat,
  "chat_message_sent": chat_message_sent,
  "header-recent_search_clicked": header_recent_search_clicked,
  "header-popular_search_clicked": header_popular_search_clicked,
  "header-popular_collection_clicked": header_popular_collection_clicked,
  "header-popular_help_clicked": header_popular_help_clicked,
  "header-popular_search_closed": header_popular_search_closed,
};

function strip_uri_params(url) {
  try {
    return url.split('?')[0].split('#')[0];
  } catch (e) {
    console.log(e);
    return url;
  }
}

function customer_auth_start() {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'customer_auth_start', {});
  }
  trackAmplitude('customer_auth_start', {});
}

function trackAmplitude(eventName, payload) {
  if (typeof window !== 'undefined' && window.amplitude && typeof window.amplitude.track === 'function') {
    window.amplitude.track(eventName, payload);
  }
}

function pdp_vipps_express_clicked(event, element) {
  gtag('event', 'vipps_express_clicked', {});
  trackAmplitude('vipps_express_clicked', {});
}

function autocomplete_open_chat(event, element) {
  gtag('event', 'autocomplete_open_chat', {});
  trackAmplitude('autocomplete_open_chat', {});
}

// First typed send in the inline Vera composer (.vi-input). Header search and
// villoid-chat:open only seed the chat and must not fire (Asana 1218401025397653).
// Side-panel #vc-send stays on the GCS widget. Payload is empty {} — GDPR: do
// not send the user message (Pernille Vold / wojtek).
var chatMessageSentOnce = false;
var lastChatMessageSentQuery = '';
var lastChatMessageSentAt = 0;

function track_chat_message_sent(query) {
  if (chatMessageSentOnce) return;
  if (!query || typeof query !== 'string') return;
  const trimmed = query.trim();
  if (!trimmed) return;
  // Enter can also synthesize a button click; same query within 500ms is one send.
  const now = Date.now();
  if (trimmed === lastChatMessageSentQuery && now - lastChatMessageSentAt < 500) return;
  lastChatMessageSentQuery = trimmed;
  lastChatMessageSentAt = now;
  gtag('event', 'chat_message_sent', {});
  trackAmplitude('chat_message_sent', {});
  chatMessageSentOnce = true;
  track_vera_engaged('chat_message_sent');
}

function composerQuery(wrap) {
  if (!wrap) return '';
  const field = wrap.querySelector('input');
  return field && field.value ? field.value : '';
}

function chat_message_sent(event, element) {
  const wrap = element.closest && element.closest('.vi-input');
  const query = (element.getAttribute && element.getAttribute('data-query')) || composerQuery(wrap);
  track_chat_message_sent(query);
}

// Vera engagement beyond the initial SERP answer (Asana 1218390524155224).
// A plain search that Vera auto-answers is one turn and must NOT count; this
// fires once per page load the first time the shopper actually works the chat
// block, so sessions can be split on "has vera_engaged" for turn counting.
// Read from the DOM, not from the widget's own events: `inline_block_shown`
// / `_expanded` carry mode ("search" | "collection"), which is the trigger and
// never changes once the shopper engages.
var veraEngagedOnce = false;

function track_vera_engaged(trigger) {
  if (veraEngagedOnce) return;
  veraEngagedOnce = true;
  gtag('event', 'vera_engaged', { trigger: trigger });
  trackAmplitude('vera_engaged', { trigger: trigger });
}

// .vi-expanded is the inline block opened ("Se AI-svaret"); body.vc-open is the
// side panel. Watching classes rather than clicks catches every route in —
// toggle, autocomplete entry, villoid-chat:open — with one observer.
function veraEngagementFromDom() {
  if (veraEngagedOnce) return true;
  if (document.querySelector('.vi-block.vi-expanded')) {
    track_vera_engaged('inline_expanded');
    return true;
  }
  if (document.body && document.body.classList.contains('vc-open')) {
    track_vera_engaged('chat_panel_opened');
    return true;
  }
  return false;
}

function initVeraEngagedTracking() {
  if (typeof MutationObserver === 'undefined') return;
  if (veraEngagementFromDom()) return;
  // Class changes are frequent on a storefront, so stop watching once it fires.
  const observer = new MutationObserver(function() {
    if (veraEngagementFromDom()) observer.disconnect();
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  // "Se flere" grows the product grid without touching either class.
  document.addEventListener('click', function(event) {
    const target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('.vc-show-more')) track_vera_engaged('show_more');
  }, true);
}

function initChatMessageSentTracking() {
  document.addEventListener('click', function(event) {
    const wrap = event.target && event.target.closest && event.target.closest('.vi-input');
    if (!wrap) return;
    if (!event.target.closest('button')) return;
    track_chat_message_sent(composerQuery(wrap));
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter') return;
    const wrap = event.target && event.target.closest && event.target.closest('.vi-input');
    if (!wrap) return;
    track_chat_message_sent(event.target.value);
  }, true);
}

// Vera product_seen_chat is gated in assets/vera-product-seen-chat.js — the GCS
// widget fires on ProductCard mount/IO with no inline-expanded check.

// Empty-search popup ("Populære søk") — rendered by the Nosto bundle in light DOM, so the body
// click-delegation below catches these via their data-event attrs (see villoid-nosto History.jsx).

// 1-based position of the clicked link within its own section (søk / kolleksjoner / hjelp), so we
// can see which slot was clicked. Scoped to the section element so the duplicate desktop/mobile
// search popups can't offset the index.
function popular_link_position(element, sectionSelector) {
  const section = element.closest(sectionSelector);
  if (!section) return null;
  const eventName = element.getAttribute('data-event');
  const links = Array.from(section.querySelectorAll('[data-event="' + eventName + '"]'));
  const index = links.indexOf(element);
  return index === -1 ? null : index + 1;
}

function header_popular_search_clicked(event, element) {
  const payload = {
    event_label: (element.innerText || '').trim(),
    value: strip_uri_params(element.getAttribute('href') || ''),
    position: popular_link_position(element, '.ns-popular-searches'),
    variant: (window.villoidSearchVariant || 'control'),
  };
  gtag('event', 'popular_search_clicked', payload);
  trackAmplitude('popular_search_clicked', payload);
}

// Recent-search ("Nylige søk") item click. Recent items are HistoryElement triggers, not links, so
// there's no href — event_label is the query text. Fires in both popup variants; position is scoped
// to the popup wrapper (.ns-w-100), filtered to recent items by the shared data-event.
function header_recent_search_clicked(event, element) {
  const payload = {
    event_label: (element.innerText || '').trim(),
    position: popular_link_position(element, '.ns-w-100'),
    variant: (window.villoidSearchVariant || 'control'),
  };
  gtag('event', 'recent_search_clicked', payload);
  trackAmplitude('recent_search_clicked', payload);
}

function header_popular_collection_clicked(event, element) {
  const payload = {
    event_label: (element.innerText || '').trim(),
    value: strip_uri_params(element.getAttribute('href') || ''),
    position: popular_link_position(element, '.ns-popular-collections'),
    variant: (window.villoidSearchVariant || 'control'),
  };
  gtag('event', 'popular_collection_clicked', payload);
  trackAmplitude('popular_collection_clicked', payload);
}

function header_popular_help_clicked(event, element) {
  const payload = {
    event_label: (element.innerText || '').trim(),
    value: strip_uri_params(element.getAttribute('href') || ''),
    position: popular_link_position(element, '.ns-popular-help'),
    variant: (window.villoidSearchVariant || 'control'),
  };
  gtag('event', 'popular_help_clicked', payload);
  trackAmplitude('popular_help_clicked', payload);
}

function header_popular_search_closed(event, element) {
  const payload = { variant: (window.villoidSearchVariant || 'control') };
  gtag('event', 'popular_search_closed', payload);
  trackAmplitude('popular_search_closed', payload);
}

// Impression — not a click, so it can't go through the delegation. Reused for variantB by
// villoidSearchPopupExposed below (called from villoid-nosto History.jsx on popup-visible).
function header_popular_search_viewed() {
  const payload = { variant: (window.villoidSearchVariant || 'control') };
  gtag('event', 'popular_search_viewed', payload);
  trackAmplitude('popular_search_viewed', payload);
}

// Search-popup A/B (search_popup_variant): called from villoid-nosto History.jsx when the
// popup becomes visible, for BOTH variants, so exposure is symmetric.
//   - GA4: a normal 'search_popup_exposed' event (GA4 has no exposure concept).
//   - Amplitude: the Experiment $exposure, owned by assets/ab_test_search_popup.js.
// The popular_searches-only "viewed" impression reuses header_popular_search_viewed above.
function villoidSearchPopupExposed(variant) {
  const payload = { variant: (variant || 'control') };
  gtag('event', 'search_popup_exposed', payload);
  try {
    if (typeof window.villoidFireSearchExposure === 'function') {
      window.villoidFireSearchExposure();
    }
  } catch (e) {}
  // Only count the popular-searches impression when that section is actually rendered
  // (History.jsx renders .ns-popular-searches only when hasSearches) — not on every
  // popular_searches-variant exposure, e.g. a recent-searches-only popup.
  if (variant === 'popular_searches' && document.querySelector('.ns-popular-searches')) {
    header_popular_search_viewed();
  }
}

function pdp_cart_clicked(event, element) {
  gtag('event', 'cart_clicked', {});
  trackAmplitude('cart_clicked', {});
  var text = event.target.innerText.toLowerCase();
  // The add-to-cart label is localized (theme.productStrings.preorder) and the badge label is
  // market-scoped (theme.badges.presale.label), so match those before the Norwegian literal —
  // a hardcoded 'forhåndsbestill' never fired on the Swedish market.
  var presaleLabels = [
    window.theme?.productStrings?.preorder,
    window.theme?.badges?.presale?.label,
    'forhåndsbestill'
  ];
  // data-presale-kind is authoritative - regular preorder and return presale share the
  // FORHANDSBESTILL label, so the text cannot tell them apart. Written by product-form.liquid (SSR)
  // and rewritten per variant by theme.js updateCartButton. The label sniff below stays as the
  // fallback for markup rendered before the attribute existed.
  var kind = element && element.dataset ? element.dataset.presaleKind : null;
  if (kind === 'retur') {
    pdp_cart_returpresale_clicked();
  } else if (kind === 'preorder') {
    pdp_cart_presale_clicked();
  } else if (presaleLabels.some(function (label) { return label && text.includes(label.toLowerCase()); })) {
    pdp_cart_presale_clicked();
  }
}

function pdp_cart_presale_clicked(event, element) {
  gtag('event', 'cart_presale_clicked', {});
  trackAmplitude('cart_presale_clicked', {});
}

// Return presale (incoming returns resold before restock) - deliberately a separate event from
// cart_presale_clicked so the two funnels can be split in GA4/Amplitude.
function pdp_cart_returpresale_clicked(event, element) {
  gtag('event', 'cart_returpresale_clicked', {});
  trackAmplitude('cart_returpresale_clicked', {});
}

function notifiy_stock_clicked(event, element, productId, variantId) {
  const payload = {
    productId,
    variantId,
  }
  gtag('event', 'notifiy_stock_clicked', payload);
  trackAmplitude('notifiy_stock_clicked', payload);
}

function pdp_wishlist_add(event, element) {
  const eventDetails = event?.detail?.d;
  const productId = eventDetails?.empi;
  const variantId = eventDetails?.epi;
  const payload = {
    variantId,
    productId,
  }
  gtag('event', 'wishlist_add', payload);
  trackAmplitude('wishlist_add', payload);
}

function pdp_wishlist_remove(event, element) {
  const eventDetails = event?.detail?.d;
  const productId = eventDetails?.empi;
  const variantId = eventDetails?.epi;
  const payload = {
    variantId,
    productId,
  }
  gtag('event', 'wishlist_remove', payload);
  trackAmplitude('wishlist_remove', payload);
}

function pdp_colorswatch_clicked(event, element) {
  gtag('event', 'colorswatch_clicked', {});
  trackAmplitude('colorswatch_clicked', {});
}

function pdp_sizeguide_clicked(event, element) {
  gtag('event', 'sizeguide_clicked', {});
  trackAmplitude('sizeguide_clicked', {});
}

function pdp_delivery_clicked(event, element) {
  gtag('event', 'delivery_clicked', {});
  trackAmplitude('delivery_clicked', {});
}

function pdp_return_clicked(event, element) {
  gtag('event', 'return_clicked', {});
  trackAmplitude('return_clicked', {});
}

function pdp_recommendation_clicked(event, element) {
  // Ignore swipe/drag in gallery — only track genuine clicks
  if (window._lastPointerDownPos) {
    const dx = Math.abs(event.clientX - window._lastPointerDownPos.x);
    const dy = Math.abs(event.clientY - window._lastPointerDownPos.y);
    if (dx > 10 || dy > 10) {
      return;
    }
  }

  const item = element.closest('.vertex-item, .nosto-item');
  const variantOption = element.querySelector('.ns-dropdown-option[data-variant-id]');

  let recommendation_header = '';
  try {
    recommendation_header = element?.closest('.shopify-app-block')?.querySelector('.section-header__title')?.innerText;
  } catch (e) {
    console.log(e);
  }

  const eventData = {
    recommendation_type: element.getAttribute('data-recommendation-type') || 'unknown',
    product_id: item?.getAttribute('data-product-id'),
    variant_id: variantOption?.getAttribute('data-variant-id') || item?.getAttribute('data-variant-id'),
    recommendation_header,
  };

  gtag('event', 'pdp-recommendation_clicked', eventData);
  trackAmplitude('pdp-recommendation_clicked', eventData);
}

function pdp_recommendations_seen(event, element) {
  const abTestKey = 'ab_test_27-10-2025_recommendations_80_20';
  let provider = 'unknown';

  try {
    const variant = localStorage.getItem(abTestKey) || '';
    if (variant.includes('vertex')) {
      provider = 'vertex';
    } else if (variant.includes('nosto')) {
      provider = 'nosto';
    }
  } catch (err) {
    provider = 'unknown';
  }

  let recommendation_header = '';
  try {
    recommendation_header = element?.closest('.shopify-app-block')?.querySelector('.section-header__title')?.innerText;
  } catch (e) {
    console.log(e);
  }

  const eventData = {
    recommendation_type: provider,
    recommendation_header,
  };

  gtag('event', 'recommendations_seen', eventData);
  trackAmplitude('recommendations_seen', eventData);
}

// 1-based position of a recommendation card inside its own app block, so a batched
// product_recommendation_seen carries the order products were shown in. Scoped to the same
// block that supplies recommendation_header, so indices line up with the batch grouping.
// Selector matches pdp_recommendation_clicked's '.vertex-item, .nosto-item' convention.
function recommendation_position(element) {
  const container = element.closest('.shopify-app-block') || element.closest('.vertex-container');
  if (!container) return null;
  const cards = Array.from(container.querySelectorAll('.nosto-item, .vertex-item'));
  const index = cards.indexOf(element);
  return index === -1 ? null : index + 1;
}

function product_recommendation_seen(element, provider) {
  const variantOption = element.querySelector('.ns-dropdown-option[data-variant-id]');

  //If the product id is not set, we skip the tracking  
  if (element.getAttribute('data-product-id') === null) {
    return;
  }

  let recommendation_header = '';
  try {
    recommendation_header = element?.closest('.shopify-app-block')?.querySelector('.section-header__title')?.innerText;
  } catch (e) {
    console.log(e);
  }
  
  // Batched: product_id / variant_id now travel inside items[], while
  // recommendation_type / recommendation_header stay top-level event params.
  queue_impression({
    eventName: 'product_recommendation_seen',
    groupKey: provider + '|' + recommendation_header,
    params: {
      recommendation_type: provider,
      recommendation_header,
    },
    item: {
      item_id: element.getAttribute('data-product-id'),
      item_variant: variantOption?.getAttribute('data-variant-id') || element.getAttribute('data-variant-id'),
      index: recommendation_position(element),
    },
    toAmplitude: true,
  });
}

function back_in_stock_popup_ok_clicked(event, element) {
  gtag('event', 'ok_clicked', {});
  trackAmplitude('ok_clicked', {});
}

function back_in_stock_submitted(event, variant_id, product_id) {
  const payload = {
    variant_id,
    product_id,
  };
  gtag('event', 'back_in_stock_submitted', payload);
  trackAmplitude('back_in_stock_submitted', payload);
}

function footer_returnpolicy_clicked(event, element) {
  gtag('event', 'returnpolicy_clicked', {});
  trackAmplitude('returnpolicy_clicked', {});
}

function footer_buyterms_clicked(event, element) {
  gtag('event', 'buyterms_clicked', {});
  trackAmplitude('buyterms_clicked', {});
}

function footer_contact_clicked(event, element) {
  gtag('event', 'contact_clicked', {});
  trackAmplitude('contact_clicked', {});
}

function footer_about_clicked(event, element) {
  gtag('event', 'about_clicked', {});
  trackAmplitude('about_clicked', {});
}

function footer_newsletter_clicked(event, element) {
  gtag('event', 'newsletter_clicked', {});
  trackAmplitude('newsletter_clicked', {});
}

// Campaign banners come from two generations of markup.
//  - Legacy sections (slideshow, promo-grid, image-grid, …) tag their own element with data-event
//    and lay an EMPTY overlay <a> over the image, so a click lands on the anchor itself.
//  - The Hero slideshow theme block renders every banner on today's homepage. It is AI-generated
//    and is rewritten whenever it is regenerated in the theme editor, so it carries no theme-owned
//    attribute and is matched from here instead, by the class prefix its per-instance classes share
//    (…__slide-link-<ai_gen_id>). It wraps the <img> in the anchor, so a click lands on the image
//    and only `element` — the ancestor the delegation walked up to — carries the href.
const HERO_BLOCK_CAMPAIGN_SELECTOR = 'a[class*="ai-hero-slideshow__slide-link-"]';
const CAMPAIGN_SELECTOR = '[data-event="front-campaign_clicked"], ' + HERO_BLOCK_CAMPAIGN_SELECTOR;

// image-grid.liquid marks a <div> with a plain href attribute, which has no `.href` property.
function campaign_link_path(element) {
  var href = element.href || element.getAttribute('href') || '';
  if (!href) return '';
  var path;
  try {
    path = new URL(href, window.location.origin).pathname;
  } catch (e) {
    path = strip_uri_params(href);
  }
  // Host-agnostic on purpose: villoid.se serves the same banners, and the old hardcoded
  // 'https://villoid.no/…' strip left those reporting a full URL instead of a slug.
  return path.replace('/collections/', '').replace('/pages/', '');
}

// Flat 0..N index across every campaign element on the page (all blocks and all their slides),
// not a per-block slot — matches what the legacy handlers reported. Document order, so the two
// markup generations share one numbering.
function campaign_position(element) {
  return [...document.querySelectorAll(CAMPAIGN_SELECTOR)].indexOf(element);
}

// The Hero slideshow anchor holds both a desktop and a mobile <img> and CSS shows exactly one, so
// the hidden one has no offsetParent. Legacy slideshow sections keep the <img> outside the overlay
// anchor, in the enclosing .slideshow__slide.
function campaign_image_filename(element) {
  var scope = element.closest('.slideshow__slide') || element;
  var images = [...scope.querySelectorAll('img')];
  var img = images.find(function (candidate) { return candidate.offsetParent !== null; }) || images[0];
  if (!img) return undefined;
  return strip_uri_params(img.currentSrc || img.src).split('/').pop();
}

function front_campaign_clicked(event, element) {
  var payload = {
    event_category: campaign_link_path(element),
    event_label: campaign_position(element),
    value: campaign_image_filename(element),
  };
  gtag('event', 'campaign_clicked', payload);
  trackAmplitude('campaign_clicked', payload);
}

const campaignsPositionsViewed = new Set();

function front_campaign_viewed(event, element) {
  var path = campaign_link_path(element);
  if (!path) {
    console.log("No href found in element");
    return;
  }
  var position = campaign_position(element);
  if (campaignsPositionsViewed.has(position)) {
    return;
  }
  campaignsPositionsViewed.add(position);
  var payload = {
    event_category: path,
    event_label: position,
    value: campaign_image_filename(element),
  };
  gtag('event', 'campaign_viewed', payload);
  try {
    trackAmplitude('campaign_viewed', payload);
  } catch (e) {
    console.log(e);
  }
}

function front_category_clicked(event, element) {
  gtag('event', 'category_clicked', {});
  trackAmplitude('category_clicked', {});
}

function front_special_category_viewed() {
  gtag('event', 'category_viewed', {});
  trackAmplitude('category_viewed', {});
}

function front_recos_news_clicked(event, element) {
  gtag('event', 'recos_news_clicked', {});
  trackAmplitude('recos_news_clicked', {});
}

function category_buttons_clicked(event, element) {
  const category = element.getAttribute('data-category') || 'unknown';
  const href = element.getAttribute('href') || '';
  
  gtag('event', 'category_buttons_clicked', {
    event_label: category,
    value: strip_uri_params(href)
  });
  trackAmplitude('category_buttons_clicked', {
    event_label: category,
    value: strip_uri_params(href)
  });
}

function front_recos_person_clicked(event, element) {
  gtag('event', 'recos_person_clicked', {});
  trackAmplitude('recos_person_clicked', {});
}

// `element` is the [data-event] node the click walked up to. In the accordion menu the click lands on a
// <button> nested inside the data-event <a>, so reading event.target gave null category/value there.
function header_menu_item_clicked(event, element) {
  const payload = {
    event_category: element.getAttribute("data-linktype"),
    event_label: element.innerText,
    value: strip_uri_params(element.getAttribute("href")),
  };
  // The mobile drawer exists in two A/B arms with different items; the property lets clicks be split by arm.
  if (element.closest('#NavDrawer, #NavDrawerClassic')) {
    Object.assign(payload, mobile_menu_props());
  }
  gtag('event', 'menu_item_clicked', payload);
  trackAmplitude('menu_item_clicked', payload);
}

// Mobile menu A/B test (flag mobile-menu, assets/ab_test_mobile_menu.js). Open/close are called from
// theme.js Drawers.open/close for the nav drawer, so both arms fire at the same moment. menu_variant is the
// arm that was rendered, which can differ from the Amplitude allocation on a visitor's first session.
function mobile_menu_props() {
  return { menu_variant: window.villoidMobileMenuVariant || 'control' };
}

function header_menu_open() {
  // Exposure first, so the open event always follows it in the user's stream.
  if (typeof window.villoidFireMobileMenuExposure === 'function') {
    window.villoidFireMobileMenuExposure();
  }
  gtag('event', 'mobile_menu_open', mobile_menu_props());
  trackAmplitude('mobile_menu_open', mobile_menu_props());
}

function header_menu_close() {
  gtag('event', 'mobile_menu_closed', mobile_menu_props());
  trackAmplitude('mobile_menu_closed', mobile_menu_props());
}

// Treatment only: the header search stays tappable under the drill-down drawer (snippets/drawer-menu.liquid),
// the accordion drawer covers it with its overlay.
function header_menu_search() {
  gtag('event', 'mobile_menu_search', mobile_menu_props());
  trackAmplitude('mobile_menu_search', mobile_menu_props());
}

function header_wishlist_open(event, element) {
  gtag('event', 'wishlist_open', {});
  trackAmplitude('wishlist_open', {});
}

function header_account_clicked(event, element) {
  gtag('event', 'account_clicked', {});
  trackAmplitude('account_clicked', {});
}

function header_announce_delivery_clicked(event, element) {
  gtag('event', 'announce_delivery_clicked', {});
  trackAmplitude('announce_delivery_clicked', {});
}

function header_search_clicked(event, element) {
  gtag('event', 'search_clicked', {});
  trackAmplitude('search_clicked', {});
}

function header_announcement_clicked(event, element) {
  gtag('event', 'announcement_clicked', {
    event_category: event.target.innerText,
  });
  trackAmplitude('announcement_clicked', {
    event_category: event.target.innerText,
  });
}

function header_cart_open(event, element) {
  gtag('event', 'cart_open', {});
  trackAmplitude('cart_open', {});
  emit_view_cart_on_open();
}

function account_register_clicked(event, element) {
  gtag('event', 'register_clicked', {});
  trackAmplitude('register_clicked', {});
}

function account_login_clicked(event, element) {
  gtag('event', 'login_clicked', {});
  trackAmplitude('login_clicked', {});
}

function account_login_successful(event, element) {
  gtag('event', 'login_successful', {});
  trackAmplitude('login_successful', {});
}

function pages_filter_clicked(event, element) {
  gtag('event', 'filter_clicked', {});
  trackAmplitude('filter_clicked', {});
}

function pages_sort_clicked(event, element) {
  gtag('event', 'sort_clicked', {});
  trackAmplitude('sort_clicked', {});
}

function pages_badge_clicked(event, element) {
  gtag('event', 'badge_clicked', {});
  trackAmplitude('badge_clicked', {});
}

function pages_wishlist_add(event, element) {
  gtag('event', 'wishlist_add', {});
  trackAmplitude('wishlist_add', {});
}

function pages_wishlist_remove(event, element) {
  gtag('event', 'wishlist_remove', {});
  trackAmplitude('wishlist_remove', {});
}

function wishlist_add_to_cart(event, element) {
  const nsElement = element.closest('.ns-product');
  const productId = nsElement.getAttribute('data-product-id');
  const variantId = nsElement.getAttribute('data-variant-id');
  const payload = {
    productId,
    variantId,
  }
  gtag('event', 'wishlist_add_to_cart', payload);
  trackAmplitude('wishlist_add_to_cart', payload);
}

function wishlist_heart_clicked(event, element) {
  gtag('event', 'wishlist_heart_clicked', {});
  trackAmplitude('wishlist_heart_clicked', {});
}

function wishlist_heart_in_cart_clicked(event, element) {
  gtag('event', 'wishlist_heart_in_cart_clicked', {});
  trackAmplitude('wishlist_heart_in_cart_clicked', {});
}

function wishlist_share(event, element) {
  gtag('event', 'wishlist_share', {});
  trackAmplitude('wishlist_share', {});
}

function wishlist_share_visit(event, element) {
  gtag('event', 'wishlist_share_visit', {});
  trackAmplitude('wishlist_share_visit', {});
}

function cart_checkout_clicked(event, element) {
  gtag('event', 'checkout_clicked', {});
  trackAmplitude('checkout_clicked', {});
}

function bsdt_popup_shown() {
  gtag('event', 'bsdt_popup_shown', {});
  trackAmplitude('bsdt_popup_shown', {});
}

// A/B bs_dt-pop-up treatment: same trigger as bsdt_popup_shown, but the popup is skipped.
function bsdt_popup_not_shown() {
  gtag('event', 'bsdt_popup_not_shown', {});
  trackAmplitude('bsdt_popup_not_shown', {});
}

function bsdt_popup_goto_checkout(event, element) {
  gtag('event', 'bsdt_popup_goto_checkout', {});
  trackAmplitude('bsdt_popup_goto_checkout', {});
}

function cart_vipps_express_clicked(event, element) {
  gtag('event', 'vipps_express_clicked', {});
  trackAmplitude('vipps_express_clicked', {});
}

function checkout_frakt_clicked(event, element) {
  gtag('event', 'frakt_clicked', {});
  trackAmplitude('frakt_clicked', {});
}

function checkout_go_to_payment(event, element) {
  gtag('event', 'go_to_payment', {});
  trackAmplitude('go_to_payment', {});
}

function checkout_discount_clicked(event, element) {
  gtag('event', 'discount_clicked', {});
  trackAmplitude('discount_clicked', {});
}

function login_vipps(event, element) {
  gtag('event', 'login', {
    'method': 'vipps',
  });
  gtag('event', 'login_vipps', {});
  trackAmplitude('login_vipps', {});
}

function login_email_password(event, element) {
  gtag('event', 'login', {
    'method': 'email',
  });
  gtag('event', 'login_email_password', {});
  trackAmplitude('login_email_password', {});
}

function badge_click(event, element) {
  gtag('event', 'badge_click', {
    event_category: event.target.getAttribute("data-path"),
  });
  trackAmplitude('badge_click', {
    event_category: event.target.getAttribute("data-path"),
  });
}

function swatch_clicked(event, element) {
  gtag('event', 'swatch_clicked', {
    event_category: event.target.getAttribute("data-swatch-product-type"),
    event_label: event.target.getAttribute("title"),
    value: strip_uri_params(event.target.getAttribute("data-url")),
  });
  trackAmplitude('swatch_clicked', {
    event_category: event.target.getAttribute("data-swatch-product-type"),
    event_label: event.target.getAttribute("title"),
    value: strip_uri_params(event.target.getAttribute("data-url")),
  });
}

function quick_add_to_cart_clicked(event, element) {
  gtag('event', 'quick_add_to_cart_clicked', {
    value: element.getAttribute("data-product-id"),
  });
  trackAmplitude('quick_add_to_cart_clicked', {
    value: element.getAttribute("data-product-id"),
  });
}

function quick_add_to_cart_added(event, element) {
  gtag('event', 'quick_add_to_cart_added', {
    event_category: element.getAttribute("data-product-id"),
    value: element.getAttribute("data-variant-id"),
  });
  trackAmplitude('quick_add_to_cart_added', {
    event_category: element.getAttribute("data-product-id"),
    value: element.getAttribute("data-variant-id"),
  });
}

function cart_drawer_discount_code_apply(event, element) {
  const discountCode = element?.closest('.cart-discount-input__wrapper')?.querySelector('input')?.value;
  gtag('event', 'cart-drawer-discount-code', {
    value: discountCode,
  })
  trackAmplitude('cart-drawer-discount-code', {
    value: discountCode,
  });
}

function login_vipps_prompted_after_add_to_cart(event, element) {
  gtag('event', 'login-vipps-prompted-after-add-to-cart', {})
  trackAmplitude('login-vipps-prompted-after-add-to-cart', {})
}

// GA4 list identity for the collection/search grid. `item_list_name` stays the collection handle
// (or `search_<query>`) so existing reports keep working; `item_list_id` is the Shopify collection
// id, published by sections/main-collection.liquid because the Nosto-rendered grid doesn't know it.
// Returns null off a list page.
function list_context() {
  const isCollection = window.location.pathname.includes("/collections");
  const isSearch = window.location.search.includes('?q=');

  if (!isCollection && !isSearch) {
    return null;
  }

  if (!isCollection) {
    const query = new URLSearchParams(window.location.search).get('q');
    return { item_list_name: `search_${query}` };
  }

  // collectionMeta is published by sections/main-collection.liquid only, so templates using another
  // collection section fall back to the handle with no id rather than sending item_list_id: undefined.
  const meta = (window.theme && theme.collectionMeta) || {};
  const list = { item_list_name: meta.handle || window.location.pathname.split("/")[2] };

  if (meta.id) {
    list.item_list_id = String(meta.id);
  }

  return list;
}

// Nosto renders the grid into .ns-products. Scoping to it keeps a featured-collection section on
// the same template (collection-landing, designer-2025, sport) from joining the list and shifting
// every index. Falls back to document scope for the legacy Liquid grid.
function grid_product_elements() {
  const grid = document.querySelector('.ns-products') || document;
  return grid.querySelectorAll('.grid-product__content');
}

function active_currency() {
  return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NOK';
}

function grid_product_link(event, element) {
  const list = list_context();

  if (!list) {
    return;
  }

  const productElement = element.closest('.grid-product__content');
  const productElements = grid_product_elements();

  const sku = productElement.getAttribute("data-sku");
  const name = productElement.querySelector('.grid-product__vendor')?.textContent?.trim() || '';
  const brandName = productElement.querySelector('.grid-product__title--heading')?.textContent?.trim() || '';
  const currency = active_currency();
  const position = Array.from(productElements).indexOf(productElement) + 1;

  const gallery_has_been_scrolled = element.getAttribute("data-gallery-scrolled") === "true";

  select_item({ sku, name, currency, brandName, position, list, gallery_has_been_scrolled });
}

function vipps_purchase_completed(orderData) {
  if (!orderData || !orderData.oid) {
    return;
  }
  
  const eventValue = orderData.total_amount ? parseFloat(orderData.total_amount) : 0; 
  
  let variantId = orderData.variant_id;
  if (!variantId) {
    const urlParams = new URLSearchParams(window.location.search);
    variantId = urlParams.get('variant') || null;
  }
  
  const eventData = {
    transaction_id: orderData.oid,
    total_price: eventValue,
    currency: 'NOK',
    variant_id: variantId
  };
  
  if (typeof gtag === 'function') {
    gtag('event', 'vipps_paid', eventData);
  }
  
  function waitForAmplitudeAndSend() {
    if (typeof window !== 'undefined' && window.amplitude && typeof window.amplitude.track === 'function') {
      trackAmplitude('vipps_paid', eventData);
    } else {
      setTimeout(waitForAmplitudeAndSend, 100);
    }
  }

  waitForAmplitudeAndSend();

  setTimeout(() => {
    if (orderData.url && orderData.url.length >= 12) {
      window.top.location.href = 'https://s.kviq.no/redir/' + orderData.url;
    }
  }, 1100); 
}

// ---------------------------------------------------------------------------
// Impression batching
//
// Server-side tagging bills per event, and one-event-per-impression made
// view_item_list ~74% of all GA4 events. Impressions are buffered here and
// emitted as grouped events carrying a GA4 items[] array instead.
//
// Module scope is required: the collection/search grid is rendered by the Nosto
// bundle, which calls window.view_item_handler on every results change, so a
// buffer owned by that function would be discarded on each re-render.
// ---------------------------------------------------------------------------
const IMPRESSION_BATCH_SIZE = 50;

// Flush policy per impression event. Grid impressions flush promptly (the 50 cap bounds event
// count anyway). Recommendation impressions are held for the whole page visit so one event carries
// every card seen, in view order: only user inactivity or leaving the page sends them, and there
// is no max-age split. Recommendation observers run on PDP only and grid impressions on
// collection/search, so a buffer never mixes policies today; if it ever does, the entry that
// opened the buffer decides.
const IMPRESSION_POLICY = {
  view_item_list:              { idleMs: 5000,  maxAgeMs: 15000, resetIdleOnActivity: false },
  product_recommendation_seen: { idleMs: 15000, maxAgeMs: 0,     resetIdleOnActivity: true },
};

let impressionBuffer = [];
let impressionPolicy = null; // policy of the entry that opened the current buffer
let impressionTimer = null;
let impressionIdleTimer = null;
let impressionActivityStamp = 0;
const impressionSent = new Set();

function clear_impression_timers() {
  if (impressionTimer !== null) {
    clearTimeout(impressionTimer);
    impressionTimer = null;
  }
  if (impressionIdleTimer !== null) {
    clearTimeout(impressionIdleTimer);
    impressionIdleTimer = null;
  }
}

function queue_impression(entry) {
  // Dedupe key is deliberately separate from groupKey: an item counts as seen once
  // per list, while groupKey additionally splits by render so `index` stays coherent.
  // Folding the render into dedupe would re-send every item on each Nosto re-render.
  const key = entry.dedupeKey || (entry.eventName + '|' + entry.groupKey + '|' + entry.item.item_id);
  if (impressionSent.has(key)) {
    return;
  }
  impressionSent.add(key);

  // The max-age timer starts with the first buffered item and is deliberately never reset, so it
  // bounds how long the *oldest* impression can sit unsent while the user keeps scrolling. The
  // idle timer restarts on every impression (and, per policy, on user activity), so a user who
  // stops is flushed promptly instead of waiting out the bound. Idle alone is starved by
  // continuous activity, which is exactly what the recommendation policy wants.
  if (impressionBuffer.length === 0) {
    impressionPolicy = IMPRESSION_POLICY[entry.eventName] || IMPRESSION_POLICY.view_item_list;
    if (impressionPolicy.maxAgeMs > 0 && impressionTimer === null) {
      impressionTimer = setTimeout(function() { flush_impressions('max-age'); }, impressionPolicy.maxAgeMs);
    }
  }
  impressionBuffer.push(entry);
  arm_impression_idle_timer();

  if (impressionBuffer.length >= IMPRESSION_BATCH_SIZE) {
    flush_impressions('cap');
  }
}

function arm_impression_idle_timer() {
  if (impressionIdleTimer !== null) {
    clearTimeout(impressionIdleTimer);
  }
  impressionIdleTimer = setTimeout(function() { flush_impressions('idle'); }, impressionPolicy.idleMs);
}

// Scroll / pointer / key activity keeps a recommendation batch open. Throttled to one re-arm per
// second: pointermove fires 60-120x/s and a clearTimeout+setTimeout per event is pointless churn.
function note_user_activity() {
  if (impressionBuffer.length === 0 || !impressionPolicy.resetIdleOnActivity) {
    return;
  }
  const now = Date.now();
  if (now - impressionActivityStamp < 1000) {
    return;
  }
  impressionActivityStamp = now;
  arm_impression_idle_timer();
}

// The Stape web container (GTM-MHF56Q9, served first-party from yoda.villoid.no) fires its GA4
// view_item_list tag from a Custom Event trigger matching /view_collection_stape|view_item_list_stape/
// and reads ecommerce.items, ecommerce.currency, ecommerce.item_list_name and ecommerce.collection_id.
// gtag-format pushes - dataLayer.push(arguments) as ['event', name, params] - never match a Custom
// Event trigger, which is why these impressions reached Google Ads but never GA4. The gtag call stays:
// it is what feeds Ads remarketing.
function push_impressions_to_stape(payload) {
  // dataLayerVersion 2 merges objects across pushes, and a flush emits one push per group and per
  // 50-item slice, so clear ecommerce first or the next batch inherits the previous batch's items.
  dataLayer.push({ ecommerce: null });

  const ecommerce = {
    currency: payload.currency,
    item_list_name: payload.item_list_name,
    items: payload.items,
  };

  // Omitted rather than sent as undefined on templates that publish no collectionMeta
  // (sections/main-collection.liquid is the only source; see list_context).
  if (payload.item_list_id) {
    ecommerce.collection_id = payload.item_list_id;
  }

  dataLayer.push({ event: 'view_item_list_stape', ecommerce: ecommerce });
}

function flush_impressions(reason) {
  clear_impression_timers();
  impressionPolicy = null;
  if (impressionBuffer.length === 0) {
    return;
  }

  // Drain before any gtag call - a tag handler can re-enter this function.
  const entries = impressionBuffer.splice(0, impressionBuffer.length);

  // Push order is view order and `index` is DOM position, so groups and the items
  // inside them keep insertion order - never sort or renumber here.
  const groups = {};
  const order = [];
  entries.forEach(function(entry) {
    const key = entry.eventName + '|' + entry.groupKey;
    if (!groups[key]) {
      groups[key] = {
        eventName: entry.eventName,
        params: entry.params,
        toAmplitude: entry.toAmplitude,
        items: [],
      };
      order.push(key);
    }
    groups[key].items.push(entry.item);
  });

  console.log('[events] impressions flushed', { reason: reason, groups: order.length, items: entries.length });

  order.forEach(function(key) {
    const group = groups[key];
    for (let i = 0; i < group.items.length; i += IMPRESSION_BATCH_SIZE) {
      const payload = Object.assign({}, group.params, {
        items: group.items.slice(i, i + IMPRESSION_BATCH_SIZE),
      });
      gtag('event', group.eventName, payload);
      if (group.eventName === 'view_item_list') {
        push_impressions_to_stape(payload);
      }
      if (group.toAmplitude) {
        trackAmplitude(group.eventName, payload);
      }
    }
  });
}

function init_impression_flush() {
  // gtag() is async (dataLayer -> GTM -> GA4), so a flush started inside pagehide
  // is too late to reach the network. visibilitychange keeps the page alive, which
  // is why it - not pagehide - is the real safety net.
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      flush_impressions('hidden');
    }
  });
  window.addEventListener('pagehide', flush_impressions_on_pagehide);

  // capture: scroll events do not bubble out of inner scrollers.
  ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'].forEach(function(type) {
    document.addEventListener(type, note_user_activity, { passive: true, capture: true });
  });
}

// Recommendation batches are held until the visitor leaves, so the leave-time send is their main
// path. Amplitude's SDK flushes its own queue on a 1s interval that a dying page may never reach;
// its docs prescribe switching to sendBeacon and flushing explicitly on pagehide.
function flush_impressions_on_pagehide() {
  flush_impressions('pagehide');
  if (window.amplitude && typeof window.amplitude.setTransport === 'function') {
    window.amplitude.setTransport('beacon');
    window.amplitude.flush();
  }
}

// Bumped once per Nosto render of the product grid; see view_item_list.
let viewItemListGeneration = 0;
let viewItemListObserver = null;
let viewItemListGridSignature = '';

function view_item_list({ sku, name, currency, brandName, position, list, listGeneration }) {
  queue_impression({
    eventName: 'view_item_list',
    // Each Nosto render gets its own event: page 1 and page 2 share item_list_name
    // but both restart `index` at 1, so merging them would collide positions.
    groupKey: list.item_list_name + '|' + listGeneration,
    dedupeKey: 'view_item_list|' + list.item_list_name + '|' + sku,
    params: {
      currency: currency,
      ...list,
    },
    item: {
      item_id: sku,
      item_name: name,
      item_brand: brandName,
      index: position,
    },
    toAmplitude: false,
  });
}

function select_item({ sku, name, currency, brandName, position, list, gallery_has_been_scrolled }) {
  const payload = {
    currency: currency,
    ...list,
    items: [
      {
        item_id: sku,
        item_name: name,
        item_brand: brandName,
        index: position,
        gallery_has_been_scrolled,
      }
    ]
  };
  gtag("event", "select_item", payload);
}

function view_item_handler() {
  const list = list_context();

  if (!list) {
    return;
  }

  const productElements = grid_product_elements();
  const viewedProducts = new WeakSet(); // Prevents duplicates

  if (productElements.length === 0) {
    console.log(`Will retry in 1s because products not yet loaded`);
    setTimeout(view_item_handler, 1000);
    return;
  }

  // Nosto rebuilds every card on pagination, sort and filter, so the previous observer is watching
  // detached nodes. Left attached it never fires again but keeps splitting groupKey across
  // generations, which fragments the batching this file exists for.
  if (viewItemListObserver) {
    viewItemListObserver.disconnect();
  }

  // Nosto re-renders the grid on wishlist and swatch state changes too, not only on a real
  // results change. Bumping every time split one list across several view_item_list events,
  // because groupKey carries the generation. Only a different card set restarts `index`, so
  // only that needs a new generation. Pagination replaces the grid rather than appending to it
  // (villoid-nosto components/Pagination.jsx), so comparing the SKU list is enough.
  const gridSignature = Array.from(productElements)
    .map(el => el.getAttribute('data-sku'))
    .join(',');

  if (gridSignature !== viewItemListGridSignature) {
    viewItemListGeneration += 1;
    viewItemListGridSignature = gridSignature;
  }

  const listGeneration = viewItemListGeneration;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const productElement = entry.target;

        if (viewedProducts.has(productElement)) {
          return; // Already tracked
        }

        const productLink = productElement.querySelector('a.grid-product__link');
        const productTitle = productElement.querySelector('.grid-product__vendor')?.textContent?.trim() || '';
        const sku = productElement.getAttribute("data-sku");
        const brandName = productElement.querySelector('.grid-product__title--heading')?.textContent?.trim() || '';

        if (productLink && sku) {
          view_item_list({
            list,
            listGeneration,
            name: productTitle,
            brandName,
            sku,
            currency: active_currency(),
            position: Array.from(productElements).indexOf(productElement) + 1,
          });

          viewedProducts.add(productElement);
          observer.unobserve(productElement); // Stop observing this element
        }
      }
    });
  }, {
    // 0.5, not a stricter value: the observer samples roughly per frame, and a flick-scroll takes a
    // card 0% -> ~40% -> 0% between samples, so a 0.95 threshold never sees it. Measured on a 390px
    // viewport scrolling fast, 0.95 recorded 32 of the 80 cards the shopper actually passed; 0.5
    // recorded all 80, and still records all 96 scrolling slowly. 0.5 is also the IAB impression
    // standard (half the pixels visible).
    threshold: 0.5,
    rootMargin: '0px 0px -5% 0px'
  });

  viewItemListObserver = observer;

  productElements.forEach(el => {
    observer.observe(el);
  });
}

function checkIfElementIsIntersecting(el, threshold = 0.95) {
  // check if el is intersecting with the viewport
  const rect = el.getBoundingClientRect();
  return rect.top <= window.innerHeight * threshold && rect.bottom >= window.innerHeight * (1 - threshold);
}

// create observer on / page similar to view_item_handler
function home_page_campaign_view_handler() {
  // do it only on /
  const isHomePage = window.location.pathname == "/"

  if (!isHomePage) {
    return;
  }

  // Every campaign banner on the page, both markup generations — see CAMPAIGN_SELECTOR.
  // Inactive slideshow slides are display:none, so the observer stays quiet until autoplay
  // rotates them in, which is exactly when they become a real impression.
  const campaignElements = document.querySelectorAll(CAMPAIGN_SELECTOR);
  const viewedCampaigns = new WeakSet(); // Prevents duplicates

  if (campaignElements.length === 0) {
    console.log(`Will retry in 1s because products not yet loaded`);
    setTimeout(home_page_campaign_view_handler, 1000);
    return;
  }

  // on main page we have to track initially visible campaigns
  setTimeout(() => {
    campaignElements.forEach(el => {
      const elementIsIntersecting = checkIfElementIsIntersecting(el);
      console.log(`[events.js] home_page_campaign_view_handler`, {
        el,
        elementIsIntersecting,
      })
      if (elementIsIntersecting && !viewedCampaigns.has(el)) {
        viewedCampaigns.add(el);
        front_campaign_viewed(null, el);
      }
    });
  }, 500);

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const campaignElement = entry.target;

        if (viewedCampaigns.has(campaignElement)) {
          return; // Already tracked
        }

        console.log({
          campaignElement,
        })

        if (campaignElement) {
          front_campaign_viewed(null, campaignElement);

          viewedCampaigns.add(campaignElement);
          observer.unobserve(campaignElement); // Stop observing this element
        }
      }
    });
  }, {
    threshold: 0.95,
    rootMargin: '0px 0px -5% 0px'
  });

  campaignElements.forEach(el => {
    observer.observe(el);
  });
}

function nosto_recommendations_view_handler() {
  const nostoElements = document.querySelectorAll('.nosto-item');
  const viewedNostoItems = new WeakSet();

  if (nostoElements.length === 0) {
    setTimeout(nosto_recommendations_view_handler, 1000);
    return;
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const nostoElement = entry.target;

        if (viewedNostoItems.has(nostoElement)) {
          return;
        }
        
        product_recommendation_seen(nostoElement, 'nosto');
        viewedNostoItems.add(nostoElement);
        observer.unobserve(nostoElement);
      }
    });
  }, {
    threshold: 0.75,
    rootMargin: '0px 0px -5% 0px'
  });

  nostoElements.forEach(el => {
    observer.observe(el);
  });
}

let vertexObserver = null;
const viewedVertexItems = new WeakSet();

function vertex_recommendations_view_handler() {
  const vertexElements = document.querySelectorAll('.vertex-container .vertex-item');

  if (vertexElements.length === 0) {
    setTimeout(vertex_recommendations_view_handler, 1000);
    return;
  }

  if (vertexObserver) {
    vertexObserver.disconnect();
  }

  vertexObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const vertexElement = entry.target;

        if (viewedVertexItems.has(vertexElement)) {
          return;
        }

        product_recommendation_seen(vertexElement, 'vertex');
        viewedVertexItems.add(vertexElement);
        observer.unobserve(vertexElement);
      }
    });
  }, {
    threshold: 0.75,
    rootMargin: '0px 0px -5% 0px'
  });

  vertexElements.forEach(el => {
    if (!viewedVertexItems.has(el)) {
      vertexObserver.observe(el);
    }
  });
}

function emit_view_cart_on_open() {
  if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
    theme.cart.getCart().then(function(cart) {
      const items = (cart.items || []).map(function(item) {
        return {
          item_id: String(item.variant_id || item.id || ''),
          item_name: item.title,
          quantity: item.quantity,
          price: item.price / 100
        };
      });
      const payload = { 
        currency: cart.currency,
        value: cart.total_price / 100,
        items: items};
      gtag('event', 'view_cart', payload);
      trackAmplitude('view_cart', payload);

      window?.swymAddEventListeners();
    })
  }
}

function track_search_query(query) {
  if (!query || typeof query !== 'string') return;
  const trimmed = query.trim();
  if (!trimmed) return;

  const searchInput = document.querySelector('.boost-pfs-search-box');
  let productDetails = [];
  if (searchInput?.dataset?.productDetails) {
    try { productDetails = JSON.parse(searchInput.dataset.productDetails) || []; } catch (_) {}
  }

  const items = productDetails.map(product => ({
    item_id: product.product.id,
  }));

  const payload = {
    eventType: 'search',
    searchQuery: trimmed,
    pageCategories: window.location.pathname.split('/').filter(Boolean),
    items: items
  };

  gtag('event', 'autocomplete_search', payload);
  trackAmplitude('autocomplete_search', payload);
}

function track_search_with_suggestion(query, suggestion, position, attributionToken) {
  const valid = query && suggestion && typeof position === 'number' && position > 0 && attributionToken;
  if (!valid) return;

  const searchInput = document.querySelector('.boost-pfs-search-box');
  let productDetails = [];
  if (searchInput?.dataset?.productDetails) {
    try { productDetails = JSON.parse(searchInput.dataset.productDetails) || []; } catch (_) {}
  }

  const payload = {
    eventType: 'search',
    searchQuery: String(query).trim(),
    pageCategories: window.location.pathname.split('/').filter(Boolean),
    productDetails,
    completionDetail: {
      completionAttributionToken: attributionToken,
      selectedSuggestion: suggestion,
      selectedPosition: position
    }
  };

  gtag('event', 'autocomplete_search', payload);
  trackAmplitude('autocomplete_search', payload);
}

function initBoostPFSAutocompleteTracking() {
  const parseHandle = (href) => {
    if (!href) return '';
    const full = href.startsWith('http') ? href : location.origin + href;
    const i = full.indexOf('/products/');
    return i === -1 ? '' : full.slice(i + 10).split('?')[0].split('#')[0];
  };

  const bindForInput = (input) => {
    if (input.dataset.autocompleteTracking === '1') return;
    input.dataset.autocompleteTracking = '1';

    let debounceId;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (!q) return;

      clearTimeout(debounceId);
      debounceId = setTimeout(() => {
        const nostoRoot = document.querySelector('[data-nosto-element="autocomplete"]');
        const anchors = nostoRoot
          ? Array.from(nostoRoot.querySelectorAll('a[data-nosto-element="product"], a[href*="/products/"]'))
          : [];
        const limited = anchors.slice(0, 12);

        limited.forEach((a, idx) => {
          if (a.dataset.trackingBound !== '1') {
            a.dataset.trackingBound = '1';
            a.addEventListener('click', () => {
              const suggestion = (a.textContent || '').trim();
              track_search_with_suggestion(q, suggestion, idx + 1, 'boost_pfs_suggestion');
            });
          }
        });

        const handles = limited
          .map((a) => parseHandle(a.getAttribute('href') || a.href))
          .filter(Boolean);
        const uniqueHandles = Array.from(new Set(handles));

        Promise.all(
          uniqueHandles.map((h) =>
            fetch(`${location.origin}/products/${h}.json`)
              .then((r) => (r.ok ? r.json() : null))
              .then((j) => ({ handle: h, id: j?.product?.id ? String(j.product.id) : '' }))
              .catch(() => ({ handle: h, id: '' }))
          )
        ).then((results) => {
          const seen = new Set();
          const productDetails = [];
          results.forEach(({ handle, id }) => {
            if (!id || seen.has(id)) return;
            seen.add(id);
            productDetails.push({ product: { id } });
          });
          if (productDetails.length) {
            input.dataset.productDetails = JSON.stringify(productDetails);
          }
          track_search_query(q);
        });
      }, 500);
    });
  };

  const poll = setInterval(() => {
    const inputs = document.querySelectorAll('.boost-pfs-search-box');
    if (!inputs.length) return;
    clearInterval(poll);
    inputs.forEach(bindForInput);
  }, 100);
}

function addEventsTrackClickEventListener() {
  document.body.addEventListener("pointerdown", function(event) {
    window._lastPointerDownPos = { x: event.clientX, y: event.clientY };
  }, true);

  document.body.addEventListener("click", function(event) {
    // Navigation is the last chance to send buffered impressions: gtag() is async,
    // so a flush started during pagehide never reaches the network. Deliberately not
    // pointerdown - every touch scroll starts with one, which would defeat batching.
    if (impressionBuffer.length && event.target.closest && event.target.closest('a[href]')) {
      flush_impressions('navigation');
    }

    let alreadyTriggeredCallbacks = [];
    // Function to check and trigger callbacks for a single element
    function checkAndTriggerCallbacks(element) {

      var targets = [
        element.id,
        element.getAttribute("data-event"),
        element.getAttribute("name")
      ];

      // Special cases
      if (element.classList.contains("grid-image") && element.closest("#hr-slider-k621c9b8b9d0168100a6f67c7")) {
        targets.push("pdp-colorswatch");
      } else if (element.classList.contains("scr-open-size-chart")) {
        targets.push("pdp-sizeguide");
      } else if (element.classList.contains("needsclick") && element.closest("#Footer-1494292487693")) {
        targets.push("footer-newsletter_clicked");
      } else if (element.classList.contains("nosto-quickbuy")) {
        targets.push("quick-add-to-cart-clicked");
      } else if (element.classList.contains("ns-dropdown-option-quick-add-to-cart-added")) {
        const isOutOfStock = (
          element.innerText.toLowerCase().replace('\n', ' ').includes('tilbake på lager')
          ||
          element.querySelector(".option-context")?.classList?.contains('option-0-left')
        )
        if (!isOutOfStock) {
          targets.push("quick-add-to-cart-added");
        }
      } else if (element.getAttribute("data-swatch-image-uri")) {
        targets.push("swatch-clicked");
      } else if (element.matches && element.matches(HERO_BLOCK_CAMPAIGN_SELECTOR)) {
        // Hero slideshow banners wrap the <img> in the anchor, so the click lands on the image and
        // the delegation walk reaches this anchor as `element`.
        targets.push("front-campaign_clicked");
      } else if (element.classList.contains("grid-product__link")) {
        targets.push("grid-product-link");
      } else if (element.closest(".vipps-express-container[data-button-type='product']")) {
        // New Vipps app-block express button on the PDP (replaces the old #_kviq_ec button)
        targets.push("pdp-vipps_express_clicked");
      }

      for (var i = 0; i < targets.length; i++) {
        var targetId = targets[i];
        if (targetId && clickCallbacks.hasOwnProperty(targetId)) {
          const callbackFunctionName = clickCallbacks[targetId].name;
          console.log(`[events] ${callbackFunctionName}`);
          // skip if already triggered
          if (alreadyTriggeredCallbacks.includes(callbackFunctionName)) {
            console.log(`[events] skipping already triggered ${callbackFunctionName}`);
            return;
          }
          clickCallbacks[targetId](event, element);
          alreadyTriggeredCallbacks.push(callbackFunctionName);
          return true;
        }
      }
    }

    // Check the clicked element and its ancestors
    let currentElement = event.target;
    while (currentElement && currentElement !== document.body) {
      if (checkAndTriggerCallbacks(currentElement)) {
        break;
      }
      currentElement = currentElement.parentElement;
    }
  }, true);
}

function initAmplitudeSessionReplay() {
  if (!window.amplitude) {
    console.log(`[amplitude] ❌window.amplitude - not initialized`)
    setTimeout(() => {
      initAmplitudeSessionReplay();
    }, 250)
    return;
  }
  console.log(`[amplitude] ✅window.amplitude - initialized`)
  const API_KEY = "53396b10e862677a232c07f85855a79e";

  // version 1
  // const sessionReplayTracking = window.sessionReplay.plugin();
  // const instance = window.amplitude.createInstance();
  // instance.add(sessionReplayTracking);
  // instance.init(API_KEY, null, {
  //   serverZone: 'EU',
  //   serverZoneBasedApi: true,
  // });

  // version 2
  // const sessionReplayTracking = window.sessionReplay.plugin();
  // window.amplitude.add(sessionReplayTracking);
  // window.amplitude.init(API_KEY, null, {
  //   serverZone: 'EU',
  //   serverZoneBasedApi: true,
  // });
}

// Homepage scroll depth tracking (percent + absolute px steps, fire once per step)
function home_page_scroll_depth_handler() {
  /*
  1) % percentage - dynamic

  event_name: scroll_depth
  value: 10,20,30, etc.

  so on page that has 3000px
  10% - 300px
  20% - 600px
  etc.

  2) px pixel - absolute

  event_name: scroll_depth_absolute_px
  value: 850px, 1700px, etc.

  1st event - 850px
  2nd event - 1700px
  etc.
   */
  const isHomePage = window.location.pathname === "/";
  if (!isHomePage) return;

  const ABSOLUTE_STEP_PX = 850;
  const firedSteps = new Set();
  const firedAbsoluteSteps = new Set();

  function getScrollMetrics() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
    const viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    const totalScrollable = Math.max(docHeight - viewport, 1);
    const percent = (scrollTop / totalScrollable) * 100;
    return {
      percent: Math.min(100, Math.max(0, percent)),
      scrollTop,
    };
  }

  function trackScrollEvent(eventName, value) {
    try { gtag('event', eventName, { value: value }); } catch (_) {}
    try { trackAmplitude(eventName, { value: value }); } catch (_) {}
  }

  function handle() {
    const metrics = getScrollMetrics();
    const percent = metrics.percent;
    const step = Math.floor(percent / 10) * 10; // 0,10,...,100
    const shouldTrackPercent = step >= 10 && step % 10 === 0 && !firedSteps.has(step);

    if (shouldTrackPercent) {
      firedSteps.add(step);
      trackScrollEvent('scroll_depth', step);
    }

    var maxThreshold = Math.floor(metrics.scrollTop / ABSOLUTE_STEP_PX) * ABSOLUTE_STEP_PX;
    for (var threshold = ABSOLUTE_STEP_PX; threshold <= maxThreshold; threshold += ABSOLUTE_STEP_PX) {
      if (firedAbsoluteSteps.has(threshold)) {
        continue;
      }

      firedAbsoluteSteps.add(threshold);
      trackScrollEvent('scroll_depth_absolute_px', threshold);
    }

    if (shouldTrackPercent && step === 100) {
      window.removeEventListener('scroll', onScrollThrottled, { passive: true });
      window.removeEventListener('resize', onScrollThrottled);
    }
  }

  let ticking = false;
  function onScrollThrottled() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      handle();
      ticking = false;
    });
  }

  // Initial check in case above-the-fold already >10%
  setTimeout(handle, 0);

  window.addEventListener('scroll', onScrollThrottled, { passive: true });
  window.addEventListener('resize', onScrollThrottled);
}

// Close the Nosto search popup whenever the cart drawer opens. The cart-icon router and quick-add
// both dispatch `cart:open` (snippets/elite-cart-variant-bootstrap.liquid), so this covers both
// A/B cart variants. window.search_popup_dismiss is exposed by the Nosto bundle (villoid-nosto
// useMobileSearchDropdownDismiss.js); guard since that bundle loads after this script.
document.addEventListener("cart:open", function() {
  if (typeof window.search_popup_dismiss === "function") window.search_popup_dismiss();
});

function init_events_tracking() {
  addEventsTrackClickEventListener();
  init_impression_flush();
  home_page_campaign_view_handler();
  home_page_scroll_depth_handler(); // Initialize scroll depth tracking after other listeners are set
  if (window.location.href.includes('/products/')) { // only triggers on PDP, not Search, Collections or Homepage
    nosto_recommendations_view_handler();
    vertex_recommendations_view_handler();
  }
  initBoostPFSAutocompleteTracking();
  initChatMessageSentTracking();
  initVeraEngagedTracking();
  initAmplitudeSessionReplay();
}
// On the PDP this file is injected after the LCP image, i.e. usually after DOMContentLoaded already fired.
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", init_events_tracking, true);
} else {
  init_events_tracking();
}
